<!--
@Author: Calvin Green <calvin>
@Date:   2022-04-07T20:34:49+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T09:27:48+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-overlay :show="isLoading">
                    <b-form>
                        <b-row>
                            <b-col cols="12">
                                <h3 v-if="isEdit">Edit Supplier <b-button size="sm" class="thin-button" @click="addNew" variant="primary">New Supplier</b-button></h3>
                                <h3 v-else>Add New Supplier</h3>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="6">
                                <label for="">Company Name</label>
                                <b-form-input v-model="form_data.company_name"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Company Email</label>
                                <b-form-input v-model="form_data.company_email"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="12">
                                <label for="">Company Address</label>
                                <b-form-textarea v-model="form_data.company_address"></b-form-textarea>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="6">
                                <label for="">Contact Number</label>
                                <b-form-input v-model="form_data.tel_no"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Fax Number</label>
                                <b-form-input v-model="form_data.fax_no"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="6">
                                <label class="col-form-label" for="">Contact Person</label>
                                <b-form-input v-model="form_data.contact_person"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label class="col-form-label" label-for="">Supplier Type</label>
                                <b-form-select
                                    class="form-select"
                                    :options="supplierTypes"
                                    v-model="form_data.supplier_type_id"
                                ></b-form-select>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col cols="6">
                                <label for="">Supplier Activity Description</label>
                                <b-form-input v-model="form_data.activity_desc"></b-form-input>
                            </b-col>
                        </b-row>

                    </b-form>
                </b-overlay>
            </b-col>
        </b-row>
        <b-button class="w-50" variant="primary" @click="saveSupplier">Save</b-button>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
import _ from 'lodash';
export default {
    data:() => ({
        isLoading: false,
        isEdit: false,
        editData: null,
        form_data:{
            id: -1,
            supplier_type_id: '',
            company_name: '',
            company_address: '',
            tel_no: '',
            fax_no: '',
            company_email: '',
            contact_person: '',
            activity_desc: '',
        },
        has_form_loaded: false,
    }),
    computed:{
        ...facilityAdminState,
        supplierTypes() {
            var supplierTypes = [];
            supplierTypes.push({value: "", text: "Please select a type"});
            var params;
            _.forEach(this.supplier_types, function(value) {
                params = {
                    value: value.id,
                    text: value.name
                };
                supplierTypes.push(params);
            });
            return supplierTypes;
        }
    },
    methods:{
        ...facilityAdminMethods,
        updateFormData(newData){
            this.form_data = newData.form_data;
        },
        saveSupplier(){
            if (this.form_data.supplier_type_id == "" || this.form_data.company_name == "") {
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'error',
                    title:'Check your form!',
                    customClass: {     popup: 'error-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    //timer: 2000, timerProgressBar: true
                });
                return;
            }
            this.form_data.id = -1;
            this.isLoading = true;
            this.saveClientSupplier(this.form_data)
            .then(()=>{
                this.loadClientSuppliers()
                .then(()=>{
                    this.isLoading = false;
                })
                this.addNew();
            })
            .catch(()=>{
                this.isLoading = false;
            })
        },
        addNew(){
            //* Clear form input and other related vars
            this.isEdit = false;
            this.form_data = {
                supplier_type_id: '',
                company_name: '',
                company_address: '',
                tel_no: '',
                fax_no: '',
                company_email: '',
                contact_person: '',
                activity_desc: '',
            }

            //* Clear table selection css when adding a new item
            /* eslint-disable-next-line */
            let table = $$('suppliersTable');
            if(table != undefined){
                table.clearSelection();
            }
        }
    },
    mounted(){
        this.$eventHub.$on('editSupplier', this.editSupplier);
    },
    beforeDestroy(){
        this.$eventHub.$off('editSupplier');
    }
}
</script>

<style>

</style>
